// components/UploadImage/UploadImage.js
import React, { useState, useEffect } from "react";
import { Button, Box, IconButton } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CancelIcon from "@mui/icons-material/Cancel";

const SingleImageUpload = ({ onImageChange, initialImage = "" }) => {
  const [imagePreview, setImagePreview] = useState(initialImage);

  useEffect(() => {
    if (initialImage) {
      setImagePreview(initialImage);
    } else {
      setImagePreview("");
    }
  }, [initialImage]);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      setImagePreview(e.target.result);
    };
    reader.readAsDataURL(file);

    if (onImageChange) {
      onImageChange(file);
    }
  };

  const handleRemoveImage = () => {
    setImagePreview("");
    if (onImageChange) {
      onImageChange(null);
    }
  };

  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      {!imagePreview ? (
        <Button
          component="label"
          variant="contained"
          sx={{ backgroundColor: "#e7ef7d" }}
          startIcon={<CloudUploadIcon />}
        >
          Subir imagen
          <input
            type="file"
            accept="image/*"
            onChange={handleImageUpload}
            hidden
          />
        </Button>
      ) : (
        <Box sx={{ textAlign: "center" }}>
          <img
            src={imagePreview}
            alt="Vista previa"
            style={{
              maxWidth: "100%",
              maxHeight: "200px",
              marginTop: "16px",
            }}
          />
          <Box sx={{ mt: 2 }}>
            <IconButton color="error" onClick={handleRemoveImage}>
              <CancelIcon /> Eliminar
            </IconButton>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default SingleImageUpload;
